/**
 * Left-sidebar **shops** block (community feed / post pages): every shop with a
 * product count. Tapping one opens the community **Shop** page filtered to that
 * shop (all of its products), “see all” opens the shop directory.
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiShoppingBag } from 'react-icons/fi';
import { cShops, fullUrl } from '../../api';
import { useLanguage } from '../../i18n';
import { BLUE } from './brand';

export default function ShopsRail({ limit = 8 }) {
  const { t } = useLanguage();
  const [shops, setShops] = useState([]);

  useEffect(() => {
    let alive = true;
    cShops({ limit })
      .then((res) => { if (alive) setShops(res?.items || []); })
      .catch(() => { if (alive) setShops([]); });
    return () => { alive = false; };
  }, [limit]);

  if (shops.length === 0) return null;

  return (
    <section className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 p-3">
      <h3 className="flex items-center gap-2 font-extrabold text-sm px-2 py-1.5">
        <span className="w-6 h-6 rounded-lg flex items-center justify-center text-white text-xs" style={{ background: BLUE }}>
          <FiShoppingBag className="w-3.5 h-3.5" />
        </span>
        {t('shopsDirectory')}
      </h3>

      <div className="space-y-0.5">
        {shops.map((s) => (
          <Link
            key={s.id}
            to={`/shop?shop=${encodeURIComponent(s.username)}`}
            className="flex items-center gap-2.5 px-2 py-2 rounded-xl text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            {s.logo ? (
              <img src={fullUrl(s.logo)} alt={s.shop_name} className="w-8 h-8 rounded-lg object-cover shrink-0" />
            ) : (
              <span className="w-8 h-8 rounded-lg flex items-center justify-center text-white text-[10px] font-bold shrink-0" style={{ background: BLUE }}>
                {(s.shop_name || s.username).slice(0, 2).toUpperCase()}
              </span>
            )}
            <span className="flex-1 min-w-0">
              <span className="block truncate font-semibold">{s.shop_name || s.username}</span>
              <span className="block text-[11px] text-gray-400">
                {s.product_count ?? 0} {t('productsCount')}
              </span>
            </span>
          </Link>
        ))}
      </div>

      <Link to="/shops" className="mt-1.5 block px-2 py-1.5 text-xs font-bold" style={{ color: BLUE }}>
        {t('seeAll')} →
      </Link>
    </section>
  );
}
